import React, { useEffect } from 'react';
import { Dispatch } from 'redux';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { reset } from '@mm/state/actions/commonActions';
import sessionCRUDActions from '@mm/state/actions/SessionCRUDActions';
import { isFacebookConnectedSelector } from '@mm/state/selectors/userSelector';
import { Routes } from '../../../routes/top-level-routes';
import { routes } from '../../../modules/LoginRouter/routes';

export const Signout = () => {
  const isFacebookConnected = useSelector(isFacebookConnectedSelector);
  const dispatch: Dispatch<StoreState> = useDispatch();

  const history = useHistory();

  useEffect(() => {
    (async () => {
      dispatch(reset());
      await dispatch(sessionCRUDActions.clear());
      if (!isFacebookConnected) {
        history.push(Routes.login.getLink());
      }
    })();
  }, []);

  return null;
};
